"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const PendingIcon_1 = __importDefault(require("../icons/PendingIcon"));
const styles_1 = require("../styles");
const Text_1 = __importDefault(require("./Text"));
const StepProgressBar = ({ stepsTitle, currentStep }) => {
    const handleIconColor = (index) => {
        if (currentStep === index + 1)
            return styles_1.Colors.secondary;
        else if (currentStep > index)
            return styles_1.Colors.primary;
        else
            return styles_1.Colors.darkGray;
    };
    return (react_1.default.createElement(react_native_1.View, { style: styles.rowView }, stepsTitle.map((title, index) => {
        return (react_1.default.createElement(react_native_1.View, { style: styles.flex, key: `main-${index}` },
            react_1.default.createElement(react_native_1.View, { style: react_native_1.StyleSheet.flatten([styles.rowView, { marginBottom: styles_1.getSpacing() }]), key: `rowView-${index}` },
                react_1.default.createElement(react_native_1.View, { key: `rightLine-${index}`, style: react_native_1.StyleSheet.flatten([
                        styles.flex,
                        {
                            borderTopWidth: index > 0 ? 1 : 0,
                            borderTopColor: index < currentStep ? styles_1.Colors.primary : styles_1.Colors.midGray,
                        },
                    ]) }),
                react_1.default.createElement(PendingIcon_1.default, { key: index, height: 15, width: 15, fill: handleIconColor(index) }),
                react_1.default.createElement(react_native_1.View, { key: `leftLine-${index}`, style: react_native_1.StyleSheet.flatten([
                        styles.flex,
                        {
                            borderTopWidth: index + 1 < stepsTitle.length ? 1 : 0,
                            borderTopColor: index + 1 < currentStep ? styles_1.Colors.primary : styles_1.Colors.midGray,
                        },
                    ]) })),
            react_1.default.createElement(Text_1.default, { key: `title-${index}`, style: styles.title, margin: "none", color: index + 1 > currentStep ? 'default' : 'primary', variant: currentStep === index + 1 ? 'cardTitle' : 'normalBody' }, title)));
    })));
};
exports.default = StepProgressBar;
const styles = react_native_1.StyleSheet.create({
    rowView: {
        flex: 1,
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    flex: {
        flex: 1,
    },
    title: {
        textAlign: 'center',
    },
});
